// Components==============
import Checkbox from 'components/UI/CheckboxOld';
import React, { useContext } from 'react';
import { VacanciesContext } from 'screens/Vacancies/Vacancies';
import '../FilterMenu.module.scss';
// =========================

const items = [
    'Onderwijzend personeel',
    'Ondersteunend personeel',
    'Management',
];

export default function Function() {
    const { selectedEducationLevel, setSelectedEducationLevel } = useContext(
        VacanciesContext
    );

    function handleClick(option) {
        const exists = selectedEducationLevel.find(
            (current) => current === option
        );
        if (!exists)
            return setSelectedEducationLevel((prev) => [...prev, option]);

        setSelectedEducationLevel((prev) =>
            prev.filter((current) => current !== option)
        );
    }

    return (
        <div styleName="checkboxes">
            {items.map((item) => (
                <div
                    styleName={`checkbox ${
                        selectedEducationLevel.includes(item) ? 'selected' : ''
                    }`}
                    key={item}
                    onClick={() => handleClick(item)}
                >
                    <Checkbox
                        isSelected={selectedEducationLevel.includes(item)}
                    />
                    <p>{item}</p>
                </div>
            ))}
        </div>
    );
}
